var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.completed
    ? _c("div", [
        _c(
          "div",
          {
            staticStyle: { "padding-top": "60px" },
            attrs: { id: "navigationPlaceholder" },
          },
          [_c(_setup.Navigation)],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-flex m-5" },
          [
            _c("img", {
              staticClass: "mr-2 rounded-circle",
              staticStyle: { "max-height": "100px" },
              attrs: { src: _setup.logoUrl, alt: "Logo" },
            }),
            _vm._v(" "),
            _vm._l(_setup.categories, function (c, index) {
              return _c("div", { key: c.id, staticClass: "p-2" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "fg-color-gray d-flex justify-content-between align-items-center p-1 mb-2",
                    staticStyle: { "white-space": "nowrap" },
                  },
                  [
                    _c("hr", {
                      staticClass: "m-0",
                      staticStyle: { width: "100%" },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("  ")]),
                    _vm._v(" "),
                    _c("h5", { staticClass: "text-right mb-0" }, [
                      c.CategoryIcon
                        ? _c("i", {
                            staticClass: "fa",
                            class: [`fa-${c.CategoryIcon}`],
                            attrs: { "aria-hidden": "true" },
                          })
                        : _vm._e(),
                      _vm._v(
                        "\n                    " +
                          _vm._s(c.Title) +
                          "\n                "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(c.Items, function (s) {
                    return _c(
                      "div",
                      { key: s.id, staticClass: "col-sm-6 col-lg-4 mb-4" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "card",
                            staticStyle: {
                              "box-shadow": "0 0 10px rgba(0, 0, 0, 0.1)",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "card-body",
                                staticStyle: { "background-color": "#f4f4f4" },
                              },
                              [
                                _c(
                                  "h5",
                                  {
                                    staticClass:
                                      "fg-color-blue card-title text-ellipsis",
                                    attrs: { title: s.Title },
                                  },
                                  [_vm._v(_vm._s(s.Title))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  {
                                    staticClass: "list-unstyled w-100",
                                    staticStyle: {
                                      height: "150px",
                                      "overflow-x": "hidden",
                                      "overflow-y": "auto",
                                    },
                                  },
                                  _vm._l(s.Items, function (i) {
                                    return _c(
                                      "li",
                                      {
                                        key: i.id,
                                        staticClass: "mb-2 highlight-on-hover",
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "d-flex justify-content-between align-items-center card-link fg-color-gray text-ellipsis",
                                            staticStyle: {
                                              "border-bottom":
                                                "1px dotted lightgray",
                                              "padding-bottom": "3px",
                                            },
                                            attrs: {
                                              href: i.Url,
                                              target: i.OpenInNewWindow
                                                ? "_blank"
                                                : "_self",
                                              title: i.Title,
                                            },
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(i.Title),
                                              },
                                            }),
                                            _vm._v(" "),
                                            i.DueDateText
                                              ? _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      "due-date-badge",
                                                      i.DueDateClass,
                                                    ],
                                                    staticStyle: {
                                                      "white-space": "nowrap",
                                                      "font-size": "0.95em",
                                                    },
                                                    attrs: {
                                                      title: "Due date",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(i.DueDateText) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br"),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }